<template>
  <div class="major-catalog-page">
    <div class="hero-section" v-if="false">
      <div class="hero-content">
        <h1>{{ year() }}年硕士专业目录</h1>
        <p>查询当年硕士招生专业及考试科目</p>
      </div>
    </div>

    <div class="school-card-wrap" v-if="false">
      <div class="school-card">
        <div class="school-info">
          <h2>{{ schoolInfo.name }}</h2>
          <div class="school-meta">
            <span><i class="el-icon-location-outline"></i>{{ schoolInfo.city }}</span>
            <span v-if="schoolInfo.lineType">{{ schoolInfo.lineType }}</span>
            <span v-if="schoolInfo.graduateSchool">{{ schoolInfo.graduateSchool }}</span>
            <span v-if="schoolInfo.level">{{ schoolInfo.level }}</span>
          </div>
        </div>

        <el-button round class="school-home-btn" @click="handleGoDetails">院校主页<i class="el-icon-arrow-right el-icon--right"></i></el-button>
      </div>
    </div>

    <div class="page-container">
      <div class="page-title" v-if="false">开设专业</div>

      <div class="filter-card">
        <div class="search-row">
          <el-input
            v-model.trim="filters.keyword"
            placeholder="请输入专业名称"
            class="search-input"
            @keyup.enter.native="handleFilterChange"
          />
          <el-button type="primary" class="search-btn" @click="handleFilterChange">查询</el-button>
        </div>

        <div class="mode-tabs">
          <span class="mode-tab">门类</span>
          <span
            v-for="item in filterModes"
            :key="item.value"
            :class="['mode-tab', { active: filterMode === item.value }]"
            @click="handleModeChange(item.value)"
          >
            {{ item.label }}
          </span>
        </div>

        <div v-if="filterMode === 'zyxw'" class="filter-row extra-row">
          <div class="filter-label block-label">专业学位类别</div>
          <div class="filter-options option-panel">
            <span
              v-for="item in professionalCategoryOptions"
              :key="item.value"
              :class="['option-chip', { active: filters.professionalCategory === item.value }]"
              @click="setProfessionalCategory(item)"
            >
              {{ item.label }}
            </span>
          </div>
        </div>

        <div v-if="filterMode === 'xs'" class="filter-row extra-row">
          <div class="filter-label block-label">学术学位类型</div>
          <div class="filter-options option-panel">
            <span
              v-for="item in academicTypeOptions"
              :key="item.value"
              :class="['option-chip', { active: filters.academicType === item.value }]"
              @click="setAcademicType(item)"
            >
              {{ item.label }}
            </span>
          </div>
        </div>

        <div v-if="filterMode === 'xs'" class="filter-row extra-row">
          <div class="filter-label block-label">一级学科</div>
          <div class="filter-options option-panel">
            <span
              v-for="item in firstLevelOptions"
              :key="item.value"
              :class="['option-chip', { active: filters.firstLevel === item.value }]"
              @click="setFirstLevel(item)"
            >
              {{ item.label }}
            </span>
          </div>
        </div>

        <div class="filter-row">
          <div class="filter-label">学习方式</div>
          <div class="filter-options">
            <el-radio-group v-model="filters.learningMode" @change="handleFilterChange">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">全日制</el-radio>
              <el-radio label="2">非全日制</el-radio>
            </el-radio-group>
          </div>
        </div>

        <div class="filter-row filter-row-long">
          <div class="filter-label">是否接收退役大学生士兵专项计划考生报考</div>
          <div class="filter-options">
            <el-radio-group v-model="filters.soldierPlan" @change="handleFilterChange">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>

          <div class="split-line"></div>

          <div class="filter-label inline-label">是否接收少数民族高层次骨干计划考生报考</div>
          <div class="filter-options">
            <el-radio-group v-model="filters.minorityPlan" @change="handleFilterChange">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>

      <div class="result-bar">
        <div>查询到 <span class="count">{{ totalData }}</span> 个相关专业</div>
        <div class="tip">注：本系统数据由各招生单位上报，如有疑问请咨询相关招生单位。</div>
      </div>

      <div
        v-for="major in majorList"
        :key="major.id"
        class="major-block"
      >
        <div class="major-summary">
          <div class="major-summary-left">
            <div class="major-name-line">
              <span class="major-name">[{{ major.code }}]{{ major.name }}</span>
              <span class="degree-badge">{{ major.degreeType }}</span>
            </div>
            <div class="major-meta-line">
              门类：{{ major.category }}
              <span class="meta-gap"></span>
              一级学科：{{ major.firstLevel }}
            </div>
          </div>

          <div class="toggle-btn" @click="toggleExpand(major.id)">
            {{ isExpanded(major.id) ? "收起" : "展开" }}
            <i :class="isExpanded(major.id) ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
          </div>
        </div>

        <div v-if="isExpanded(major.id)" class="major-detail">
          <table class="detail-table">
            <thead>
              <tr>
                <th>院系所</th>
                <th>考试方式</th>
                <th>学习方式</th>
                <th>研究方向</th>
                <th>
                  <el-popover
                    placement="top"
                    trigger="hover"
                    content="指招生单位是否接收退役大学生士兵专项计划考生报考"
                  >
                    <span slot="reference">退役计划</span>
                  </el-popover>
                </th>
                <th>
                  <el-popover
                    placement="top"
                    trigger="hover"
                    content="指招生单位是否接收少数民族高层次骨干计划考生报考"
                  >
                    <span slot="reference">少骨计划</span>
                  </el-popover>
                </th>
                <th>指导教师</th>
                <th>拟招生人数</th>
                <th>考试科目</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in major.directions" :key="row.id">
                <td>{{ row.department }}</td>
                <td>{{ row.examType }}</td>
                <td>{{ row.learningMode }}</td>
                <td>
                  <div class="direction-cell">
                    <span>{{ row.direction }}</span>
                    <el-popover
                      v-if="row.directionDesc"
                      placement="top-start"
                      width="280"
                      trigger="hover"
                      popper-class="direction-popper"
                    >
                      <div class="direction-pop-content">{{ row.directionDesc }}</div>
                      <i slot="reference" class="el-icon-document direction-icon"></i>
                    </el-popover>
                  </div>
                </td>
                <td>{{ row.soldierPlanText }}</td>
                <td>{{ row.minorityPlanText }}</td>
                <td>
                  <el-popover
                    v-if="row.teacherText"
                    placement="top"
                    width="220"
                    trigger="hover"
                  >
                    <div>{{ row.teacherText }}</div>
                    <a slot="reference" href="javascript:;" class="table-link">查看</a>
                  </el-popover>
                  <span v-else>--</span>
                </td>
                <td>
                  <el-popover
                    v-if="row.recruitText"
                    placement="top"
                    width="220"
                    trigger="hover"
                  >
                    <div>{{ row.recruitText }}</div>
                    <a slot="reference" href="javascript:;" class="table-link">查看</a>
                  </el-popover>
                  <span v-else>--</span>
                </td>
                <td>
                  <el-popover
                    v-if="row.examPlans.length"
                    placement="left-start"
                    width="820"
                    trigger="hover"
                    popper-class="exam-popper"
                  >
                    <div class="exam-plan-pop">
                      <div
                        v-for="(plan, planIndex) in row.examPlans"
                        :key="plan.id"
                        class="exam-plan-block"
                      >
                        <div class="exam-plan-head">
                          <div
                            v-for="subject in plan.subjects"
                            :key="`${plan.id}-${subject.key}-head`"
                            class="exam-plan-head-item"
                          >
                            {{ subject.label }}
                          </div>
                        </div>

                        <div class="exam-plan-card">
                          <div
                            v-for="subject in plan.subjects"
                            :key="`${plan.id}-${subject.key}`"
                            class="exam-subject-card"
                          >
                            <div class="exam-subject-name">{{ formatSubjectText(subject) }}</div>
                            <div class="exam-subject-note">{{ subject.note || "见招生简章" }}</div>
                          </div>
                        </div>

                        <div v-if="planIndex < row.examPlans.length - 1" class="exam-plan-divider">
                          <span>或</span>
                        </div>
                      </div>

                      <div class="exam-plan-footer">注：本系统数据由各招生单位上报，如有疑问请咨询相关招生单位。</div>
                    </div>
                    <a slot="reference" href="javascript:;" class="table-link">查看</a>
                  </el-popover>
                  <span v-else>--</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pagination-wrap">
        <el-pagination
          background
          layout="prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
          :total="totalData"
          @current-change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSchoolDetailssAPI,
  getSchoolDegreeAPI,
  getSchoolDegreeTypeAPI,
  getSchoolDegreeTypeAcademicAPI,
  getSchoolDegreeTypeFirstAPI,
  getSchoolDegreeTypeGroupAPI
} from "@/api/postgraduate.js"

const EXAM_SUBJECT_MAP = [
  { key: "km1Vo", label: "政治" },
  { key: "km2Vo", label: "外语" },
  { key: "km3Vo", label: "业务课一" },
  { key: "km4Vo", label: "业务课二" }
]

export default {
  name: "MasterMajorCatalog",
  data() {
    return {
      sclId: "",
      schoolId: "",
      schoolInfo: {
        code: "",
        name: "",
        city: "",
        lineType: "",
        graduateSchool: "",
        level: ""
      },

      filterMode: "category",
      filterModes: [],

      filters: {
        keyword: "",
        learningMode: "",
        soldierPlan: "",
        minorityPlan: "",
        professionalCategory: "",
        academicType: "",
        firstLevel: ""
      },

      professionalCategoryOptions: [{ label: "全部", value: "" }],
      academicTypeOptions: [{ label: "全部", value: "" }],
      firstLevelOptions: [{ label: "全部", value: "" }],

      majorList: [],
      expandedIds: [],
      currentPage: 1,
      pageSize: 10,
      totalData: 0
    }
  },
  created() {
    this.sclId = this.$route.query.scl_id || this.$route.params.scl_id || ""
    this.initPage()
  },
  methods: {
    year() {
      return new Date().getFullYear()
    },
    handleGoDetails() {
      this.$router.push({
        path: "/pgsdetail",
        query: {
          scl_id: this.sclId
        }
      })
    },
    initPage() {
      this.getSchoolInfoHandler()
      this.getDegreeModesHandler()
    },

    async getSchoolInfoHandler() {
      try {
        const res = await getSchoolDetailssAPI(this.sclId)
        const data = res.data || {}

        this.schoolId = data.id || ""
        this.schoolInfo = {
          code: data.scl_code || this.sclId,
          name: data.scl_name || "",
          city: data.scl_city || "",
          lineType: Number(data.is_zhx) === 1 ? "自划线院校" : "",
          graduateSchool: Number(data.is_yjsy) === 1 ? "研究生院" : "",
          level: Number(data.is_syl) === 1 ? "“双一流”建设高校" : ""
        }

        if (this.schoolId) {
          this.getMajorGroupHandler(1)
        }
      } catch (error) {
        console.error("getSchoolInfoHandler error:", error)
      }
    },

    async getDegreeModesHandler() {
      try {
        const res = await getSchoolDegreeAPI()
        const list = Array.isArray(res.data) ? res.data : []
        this.filterModes = [...list]
      } catch (error) {
        console.error("getDegreeModesHandler error:", error)
      }
    },

    async getProfessionalCategoryHandler() {
      try {
        const res = await getSchoolDegreeTypeAPI()
        const list = Array.isArray(res.data) ? res.data : []
        this.professionalCategoryOptions = [
          { label: "全部", value: "" },
          ...list.map(item => ({
            label: item.name ? `(${item.code})${item.name}` : `(${item.code})`,
            value: item.code
          }))
        ]
        this.filters.professionalCategory = ""
      } catch (error) {
        console.error("getProfessionalCategoryHandler error:", error)
      }
    },

    async getAcademicTypeHandler() {
      try {
        const res = await getSchoolDegreeTypeAcademicAPI()
        const list = Array.isArray(res.data) ? res.data : []
        this.academicTypeOptions = [
          { label: "全部", value: "" },
          ...list.map(item => ({
            label: `(${item.code})${item.name}`,
            value: item.code
          }))
        ]
        this.filters.academicType = ""
        this.firstLevelOptions = [{ label: "全部", value: "" }]
        this.filters.firstLevel = ""
      } catch (error) {
        console.error("getAcademicTypeHandler error:", error)
      }
    },

    async getFirstLevelHandler(mlCode) {
      if (!mlCode) {
        this.firstLevelOptions = [{ label: "全部", value: "" }]
        this.filters.firstLevel = ""
        return
      }

      try {
        const res = await getSchoolDegreeTypeFirstAPI(mlCode)
        const list = Array.isArray(res.data) ? res.data : []
        this.firstLevelOptions = [
          { label: "全部", value: "" },
          ...list.map(item => ({
            label: `(${item.code})${item.name}`,
            value: item.code
          }))
        ]
        this.filters.firstLevel = ""
      } catch (error) {
        console.error("getFirstLevelHandler error:", error)
      }
    },

    buildGroupQueryParams(page) {
      let xwType = ""
      let mlCode = ""
      let yjxkCode = ""

      if (this.filterMode === "zyxw") {
        xwType = "zyxw"
        yjxkCode = this.filters.professionalCategory || ""
      } else if (this.filterMode === "xs") {
        xwType = "xs"
        mlCode = this.filters.academicType || ""
        yjxkCode = this.filters.firstLevel || ""
      }

      return [
        this.schoolId,
        this.filters.keyword || "",
        xwType,
        mlCode,
        yjxkCode,
        this.filters.learningMode || "",
        this.filters.soldierPlan || "",
        this.filters.minorityPlan || "",
        page,
        this.pageSize
      ]
    },

    async getMajorGroupHandler(page = 1) {
      if (!this.schoolId) return

      try {
        const params = this.buildGroupQueryParams(page)
        const res = await getSchoolDegreeTypeGroupAPI(...params)
        const pageData = res.data || {}
        const list = Array.isArray(pageData.data) ? pageData.data : []

        this.currentPage = pageData.current_page || page
        this.pageSize = pageData.per_page || this.pageSize
        this.totalData = pageData.total || 0
        this.majorList = list.map((item, index) => this.normalizeMajorItem(item, index))
        this.expandedIds = []
      } catch (error) {
        console.error("getMajorGroupHandler error:", error)
        this.majorList = []
        this.totalData = 0
      }
    },

    normalizeMajorItem(item, index) {
      return {
        id: `${item.zy_code || ""}-${index}`,
        code: item.zy_code || "",
        name: item.zy_name || "",
        degreeType: item.xw_type === "xs" ? "学术学位" : "专业学位",
        category: item.ml_code && item.ml_name ? `(${item.ml_code})${item.ml_name}` : (item.ml_name || "--"),
        firstLevel: item.yjxk_code && item.yjxk_name ? `(${item.yjxk_code})${item.yjxk_name}` : (item.yjxk_name || "--"),
        directions: Array.isArray(item.open_info_list)
          ? item.open_info_list.map((row, rowIndex) => this.normalizeDirection(row, rowIndex))
          : []
      }
    },

    normalizeDirection(row, index) {
      return {
        id: `${row.yxs_code || ""}-${row.yjfx_code || ""}-${index}`,
        department: `(${row.yxs_code || ""})${row.yxs_name || ""}`,
        examType: row.exam_name || "--",
        learningMode: this.formatStudyType(row.study_type),
        direction: `(${row.yjfx_code || "00"})${row.yjfx_name || "不区分研究方向"}`,
        directionDesc: this.cleanText(row.yjfx_desc || row.yjfx_remark || ""),
        soldierPlanText: Number(row.ty_type) === 1 ? "是" : "否",
        minorityPlanText: Number(row.gg_type) === 1 ? "是" : "否",
        teacherText: row.zd_teacher || "",
        recruitText: row.nzs_num || "",
        examPlans: this.parseExamPlans(row.kskm)
      }
    },

    formatStudyType(value) {
      if (Number(value) === 1) return "全日制"
      if (Number(value) === 2) return "非全日制"
      return "--"
    },

    parseExamPlans(kskm) {
      if (!kskm) return []

      try {
        const parsed = typeof kskm === "string" ? JSON.parse(kskm) : kskm
        if (!Array.isArray(parsed)) return []

        return parsed
          .map((plan, index) => {
            const subjects = EXAM_SUBJECT_MAP.map(subjectMeta => {
              const subject = plan ? plan[subjectMeta.key] || {} : {}
              const code = this.cleanText(subject.kskmdm || "")
              const name = this.cleanText(subject.kskmmc || "")
              const note = this.cleanText(subject.cksm || "")

              return {
                key: subjectMeta.key,
                label: subjectMeta.label,
                code,
                name,
                note
              }
            })

            const hasContent = subjects.some(subject => subject.code || subject.name || subject.note)
            if (!hasContent) return null

            return {
              id: `exam-plan-${index}`,
              subjects
            }
          })
          .filter(Boolean)
      } catch (error) {
        console.error("parseExamPlans error:", error, kskm)
        return []
      }
    },

    formatSubjectText(subject) {
      const code = subject.code ? `(${subject.code})` : ""
      return `${code}${subject.name || ""}` || "--"
    },

    cleanText(text) {
      return String(text || "").replace(/\\/g, "")
    },

    async handleModeChange(mode) {
      this.filterMode = mode
      this.currentPage = 1
      this.filters.professionalCategory = ""
      this.filters.academicType = ""
      this.filters.firstLevel = ""

      if (mode === "zyxw") {
        await this.getProfessionalCategoryHandler()
      } else if (mode === "xs") {
        await this.getAcademicTypeHandler()
      } else {
        this.professionalCategoryOptions = [{ label: "全部", value: "" }]
        this.academicTypeOptions = [{ label: "全部", value: "" }]
        this.firstLevelOptions = [{ label: "全部", value: "" }]
      }

      this.getMajorGroupHandler(1)
    },

    setProfessionalCategory(item) {
      this.filters.professionalCategory = item.value
      this.getMajorGroupHandler(1)
    },

    async setAcademicType(item) {
      this.filters.academicType = item.value
      await this.getFirstLevelHandler(item.value)
      this.getMajorGroupHandler(1)
    },

    setFirstLevel(item) {
      this.filters.firstLevel = item.value
      this.getMajorGroupHandler(1)
    },

    handleFilterChange() {
      this.getMajorGroupHandler(1)
    },

    handlePageChange(page) {
      this.getMajorGroupHandler(page)
    },

    toggleExpand(id) {
      const index = this.expandedIds.indexOf(id)
      if (index > -1) {
        this.expandedIds.splice(index, 1)
      } else {
        this.expandedIds.push(id)
      }
    },

    isExpanded(id) {
      return this.expandedIds.includes(id)
    }
  }
}
</script>

<style lang="scss" scoped>
.major-catalog-page {
  min-height: 100vh;
  background: #f5f7fb;
  color: #1f2d3d;
}

.hero-section {
  height: 200px;
  background: linear-gradient(135deg, #2386db 0%, #3b98ec 55%, #2386db 100%);
  position: relative;
  overflow: hidden;
}

.hero-section::before,
.hero-section::after {
  content: "";
  position: absolute;
  background: rgba(255, 255, 255, 0.08);
  transform: rotate(-35deg);
}

.hero-section::before {
  width: 220px;
  height: 520px;
  top: -160px;
  left: 25%;
}

.hero-section::after {
  width: 220px;
  height: 520px;
  top: -100px;
  left: 55%;
}

.hero-content {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  padding-top: 58px;
  position: relative;
  z-index: 2;
}

.hero-content h1 {
  margin: 0;
  font-size: 40px;
  font-weight: 700;
}

.hero-content p {
  margin: 14px 0 0;
  font-size: 16px;
  opacity: 0.95;
}

.school-card-wrap {
  background: #ddecfb;
}

.school-card {
  width: 1200px;
  margin: 0 auto;
  height: 114px;
  display: flex;
  align-items: center;
}

.school-info {
  flex: 1;
}

.school-info h2 {
  margin: 0 0 12px;
  font-size: 22px;
  color: #1a2533;
  font-weight: 700;
}

.school-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0 14px;
  color: #39485a;
  font-size: 15px;
}

.school-home-btn {
  border-color: #feefbd;
  color: #faa614!important;
  background: #FFFAE8!important;
  padding: 12px 26px;
}
.school-home-btn:hover{
 background: #FEEFBD!important; 
}
.page-container {
  width: 1200px;
  margin: 22px auto 0;
  padding-bottom: 40px;
}

.page-title {
  font-size: 34px;
  font-weight: 700;
  margin-bottom: 18px;
  color: #1f2d3d;
}

.filter-card {
  background: #dfeefc;
  border-radius: 10px;
  padding: 22px 26px;
  border: 1px solid #e7f1fb;
  box-shadow: 0 4px 14px rgba(31, 45, 61, 0.04);
}

.search-row {
  display: flex;
  margin-bottom: 20px;
}

.search-input {
  width: 340px;
}

.search-btn {
  margin-left: 0;
  width: 76px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.mode-tabs {
  display: flex;
  align-items: center;
  gap: 28px;
  margin-bottom: 18px;
  padding-left: 26px;
}

.mode-tab {
  font-size: 16px;
  color: #2f3f52;
  cursor: pointer;
  padding-bottom: 8px;
  border-bottom: 2px solid transparent;
}

.mode-tab.active {
  color: #2386db;
  border-bottom-color: #2386db;
}

.filter-row {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.filter-row:last-child {
  margin-bottom: 0;
}

.extra-row {
  align-items: flex-start;
}

.filter-label {
  color: #4a5c70;
  font-size: 15px;
  flex-shrink: 0;
}

.block-label {
  width: 82px;
  line-height: 24px;
  padding-top: 10px;
}

.inline-label {
  margin-left: 20px;
}

.filter-options {
  flex: 1;
  margin-left: 8px;
}

.option-panel {
  background: #edf5fd;
  border: 1px solid #d8e8f8;
  border-radius: 4px;
  padding: 12px 18px;
  min-height: 44px;
}

.option-chip {
  display: inline-block;
  margin: 0 18px 10px 0;
  font-size: 15px;
  color: #2f3f52;
  cursor: pointer;
}

.option-chip.active {
  color: #2386db;
}

.filter-row-long {
  align-items: center;
}

.split-line {
  width: 1px;
  height: 18px;
  background: #b7c8db;
  margin: 0 20px;
}

.result-bar {
  margin: 14px 0 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #5f7187;
  font-size: 14px;
}

.count {
  color: #2386db;
  font-weight: 700;
}

.tip {
  color: #8a99ab;
}

.major-block {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 18px;
  box-shadow: 0 2px 8px rgba(31, 45, 61, 0.04);
  overflow: hidden;
}

.major-summary {
  min-height: 78px;
  padding: 16px 22px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.major-summary-left {
  flex: 1;
}

.major-name-line {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.major-name {
  font-size: 18px;
  font-weight: 700;
  color: #1f2d3d;
}

.degree-badge {
  margin-left: 14px;
  padding: 3px 10px;
  font-size: 13px;
  color: #2386db;
  background: #eaf4ff;
  border-radius: 4px;
}

.major-meta-line {
  color: #5c6d82;
  font-size: 15px;
}

.meta-gap {
  display: inline-block;
  width: 26px;
}

.toggle-btn {
  color: #2386db;
  cursor: pointer;
  font-size: 15px;
  flex-shrink: 0;
  user-select: none;
}

.major-detail {
  padding: 0 22px 18px;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 1px solid #e5edf5;
}

.detail-table th,
.detail-table td {
  border: 1px solid #e5edf5;
  padding: 14px 10px;
  font-size: 14px;
  color: #253447;
  text-align: left;
  vertical-align: middle;
  background: #fff;
  word-break: break-all;
}

.detail-table th {
  background: #f6f9fc;
  font-weight: 700;
}

.detail-table th:nth-child(1),
.detail-table td:nth-child(1) {
  width: 16%;
}

.detail-table th:nth-child(2),
.detail-table td:nth-child(2),
.detail-table th:nth-child(3),
.detail-table td:nth-child(3),
.detail-table th:nth-child(5),
.detail-table td:nth-child(5),
.detail-table th:nth-child(6),
.detail-table td:nth-child(6) {
  width: 8%;
}

.detail-table th:nth-child(4),
.detail-table td:nth-child(4) {
  width: 28%;
}

.detail-table th:nth-child(7),
.detail-table td:nth-child(7),
.detail-table th:nth-child(8),
.detail-table td:nth-child(8),
.detail-table th:nth-child(9),
.detail-table td:nth-child(9) {
  width: 9%;
}

.direction-cell {
  display: flex;
  align-items: center;
  gap: 6px;
}

.direction-icon {
  color: #2386db;
  cursor: pointer;
  font-size: 15px;
  flex-shrink: 0;
}

.table-link {
  color: #2386db;
  text-decoration: none;
}

.pagination-wrap {
  margin-top: 24px;
  text-align: center;
}

.exam-plan-pop {
  max-height: 560px;
  overflow-y: auto;
  padding: 18px 20px 16px;
  background: linear-gradient(180deg, #dcebfa 0%, #eef5fc 58%, #f8fbff 100%);
  border-radius: 6px;
}

.exam-plan-block + .exam-plan-block {
  margin-top: 4px;
}

.exam-plan-head {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 24px;
  padding: 0 22px 10px;
}

.exam-plan-head-item {
  color: #14293d;
  font-size: 14px;
  font-weight: 700;
  line-height: 22px;
}

.exam-plan-card {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  column-gap: 24px;
  padding: 14px 22px 16px;
  background: #fff;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px rgba(233, 238, 246, 0.9);
}

.exam-subject-name {
  color: #101f31;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  min-height: 24px;
}

.exam-subject-note {
  margin-top: 4px;
  color: #a5afba;
  font-size: 12px;
  line-height: 20px;
  min-height: 20px;
}

.exam-plan-divider {
  position: relative;
  padding: 16px 0 18px;
  text-align: center;
  color: #8c98a6;
  font-size: 13px;
}

.exam-plan-divider::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  border-top: 1px solid rgba(202, 213, 225, 0.9);
}

.exam-plan-divider span {
  position: relative;
  z-index: 1;
  display: inline-block;
  padding: 0 16px;
  background: linear-gradient(180deg, #e7f2fc 0%, #eff6fd 100%);
}

.exam-plan-footer {
  margin-top: 12px;
  color: #7d8a98;
  font-size: 12px;
  line-height: 20px;
}

::v-deep .el-input__inner {
  height: 40px;
  line-height: 40px;
  border: 1px solid #2f8fe4;
  // border-right: none;
}

::v-deep .el-button--primary {
  background: #2f8fe4!important;
  border-color: #2f8fe4!important;
}

::v-deep .el-radio__input.is-checked + .el-radio__label {
  color: #2386db!important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  border-color: #2386db!important;
  background: #2386db!important;
}

::v-deep .direction-popper,
::v-deep .exam-popper {
  border: none;
  box-shadow: 0 10px 28px rgba(31, 45, 61, 0.14);
}

::v-deep .exam-popper {
  padding: 0;
  overflow: hidden;
}

.direction-pop-content {
  white-space: pre-line;
}
</style>
